<template>
    <div class="tc-instrument-button"
         :class="{'tc-active-instrument-button': isActive}"
         @click.stop="$emit('click')">
        <slot name="icon"/>
    </div>
</template>

<script>
export default {
    name: 'WorkspaceInstrumentButton',
    emits: [
        'click',
    ],
    props: [
        'isActive',
    ],
};
</script>

<style scoped lang="scss">
.tc-instrument-button {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    color: #333333;
    transition: 0.3s ease all;
    pointer-events: all;
    background-color: #ffffff;
}

.tc-instrument-button:hover {
    color: #00458D;
}

.tc-instrument-button:active {
    box-shadow: none;
}

.tc-active-instrument-button {
    color: #00458D !important;
    box-shadow: none;
}

</style>
